import styled from 'styled-components'
import { TopContainerHeight } from '~/constants'
import { VerticalStyledScrollBar } from '~/styles'

const TabsHeight = '40px'
const TabsGap = '1rem'

export const Container = styled.div`
  position: relative;
  height: calc(100vh - ${TopContainerHeight} - ${TabsHeight} - ${TabsGap});
  padding: 0 16px 10px;

  flex: 1;
  display: flex;
  flex-flow: column;
  overflow: hidden;
`

export const ContentContainer = styled.div`
  position: relative;
  padding: 1rem 1.5rem;
  width: 100%;
  height: calc(100% - 100px);
  display: flex;
  flex-flow: column;
  flex: 1 1 auto;
  gap: 1rem;

  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
`

export const Header = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4rem;
`

export const GridLine = styled.div.attrs(({ ...rest }: React.CSSProperties) => ({
  style: { ...rest }
}))<React.CSSProperties>`
  position: relative;
  padding-left: 0.5rem;
  width: 100%;
  display: grid;
  grid-template-columns: minmax(150px, 200px) 170px repeat(6, 1fr);
`

export const Label = styled.label`
  color: ${props => props.theme.colors.color545e6c};
  font-family: 'Inter';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.2px;
`

export const GridCell = styled.div.attrs(({ ...rest }: React.CSSProperties) => ({
  style: { ...rest }
}))<React.CSSProperties>`
  position: relative;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  border: 1px solid ${props => props.theme.colors.colordfe3e8};
`

export const GridRefCell = styled.div`
  position: relative;
  color: ${props => props.theme.colors.color122d52};
  text-align: center;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  background: ${props => props.theme.colors.colorf3f5f9};
`

export const CellRefValues = styled.div`
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  width: 100%;
  background: ${props => props.theme.colors.color122d52};
  color: ${({ theme }) => theme.zds.colors.neutral1000};
  text-align: center;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
`

export const ScrollContainer = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  position: relative;
  width: 100%;

  overflow: auto;
  flex: 1;
  ${VerticalStyledScrollBar}
`
